import Axios from 'axios';
import { API_HOST, axiosRequest, axiosRequestWithAuth, axiosInstance } from './../constants/server.constant';
import { loginService } from './login.service';
export const userService = {
    getUser,
    getUserData,
    getUserDetails,
    getUserInfo,
    getUsersByProject,
    updateUserDetails,
    updatePassword,
    cancelAccnt,
    addUser,
    editUser,
    deleteUser,
    getAllUsersById,
    recoverypassword,
    resetpassword,
    updateforgotpassword,
    addsubuser,
    getsubuserandownerdetails,
    getTestUsers,
    checkEntry,
    updatePhoneDetails,
    isSkipLimitUser,
    generateToken,
    deleteCancelUser,
    reactivateCancelledUser,
    getSuspendMsg,
    fetchActiveEmailTransfer,
    requestEmailTransfer,
    processEmailTransfer,
    cancelEmailTransfer,
    resendEmailTransferEmail
};

function getuserId() {
    return localStorage.getItem("userId");
}

function getuserEmail() {
    return localStorage.getItem("email");
}

async function getTestUsers() {
    return await axiosInstance.get(API_HOST + "/resource/test_users/", axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        })
        .catch(error => {
            return false;
        });
}

async function getUser() {
    return await axiosInstance.get("/user", axiosRequestWithAuth).then(resp => {
        loginService.setUserLocal(resp);
        return resp;
    }).catch(err => {
        throw err;
    });
}
async function getUserData() {
    return await axiosInstance.get("/user/getdataofuser", axiosRequestWithAuth).then(resp => {
        loginService.setUserLocal(resp);
        return resp;
    }).catch(err => {
        throw err;
    });
}

async function getUserDetails() {
    return await axiosInstance.get(API_HOST + "/user/" + getuserId(), axiosRequestWithAuth)
        .then(resp => {
            loginService.setUserLocal(resp);
            return resp;
        })
        .catch(error => {
            return false;
        });
}

async function getUserInfo() {
    return await axiosInstance.get(API_HOST + "/user/getuserinfo/" + getuserId(), axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return error;
    });
}

async function getUsersByProject() {
    return await axiosInstance.get(API_HOST + "/user/" + getuserId() + "/project/list", axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
}

async function updateUserDetails(data) {
    return await axiosInstance.put(API_HOST + "/user/updateuser/" + getuserId(), data, axiosRequestWithAuth)
        .then(resp => {
            return resp;
        })
        .catch(error => {
            return false;
        });
}

async function updatePassword(data) {
    return await axiosInstance.put(API_HOST + "/user/updatepassword/" + getuserId(), data, axiosRequestWithAuth)
        .then(resp => {
            return resp;
        })
        .catch(error => {
            return false;
        });
}

async function cancelAccnt(data) {

    return await axiosInstance.post(API_HOST + "/user/cancelaccount/" + getuserId(), data, axiosRequestWithAuth)
        .then(resp => {
            return resp;
        })
        .catch(error => {
            return false;
        });
}

async function addUser(data, type) {
    const requestOptions = {

        headers: {
            'Content-Type': 'application/json',
            //"Access-Control-Allow-Origin": "*" 
        }

    };
    return await axiosInstance.post(API_HOST + "/user/add/" + type + "/" + getuserId(), data, axiosRequestWithAuth)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            if(err?.response?.status === 409) {
                throw err;
            } else {
                return false;
            }
        });
}

async function getAllUsersById() {
    return await axiosInstance.get(API_HOST + "/user/" + getuserId(), axiosRequestWithAuth)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            return false;
        });
}

async function deleteUser(userid) {
    return await axiosInstance.delete(API_HOST + "/user/" + getuserId() + "?deleteId=" + userid, axiosRequestWithAuth)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            return false;
        });
}

async function editUser(userid, email, firstname, lastname) {
    const params = {
        "id": userid,
        "email": email,
        "firstName": firstname,
        "lastName": lastname
    };
    return await axiosInstance.put(API_HOST + "/user/" + getuserId(), params, axiosRequestWithAuth)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            return false;
        });
}

async function recoverypassword(username, event) {
    return await axiosInstance.post(API_HOST + "/user/recover/password/" + username + "?captcha=" + event, axiosRequestWithAuth)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            return false;
        });
}

async function resetpassword() {
    return await axiosInstance.post(API_HOST + "/user/forgotpassword/" + getuserEmail(), {}, axiosRequestWithAuth)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            return false;
        });
}

async function updateforgotpassword(token, password) {
    const requestBody = {
        newpswd: password
    };
    return await Axios.post(API_HOST + "/user/update/password/" + token, requestBody, axiosRequest)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            return false;
        });
}

async function addsubuser(token, requestBody) {
    return await Axios.post(API_HOST + "/user/addsubuser/" + token, requestBody, axiosRequest)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            return false;
        });
}

async function getsubuserandownerdetails(token) {
    return await Axios.get(API_HOST + "/user/getsubuser/" + token, axiosRequest)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            return false;
        });
}

async function checkEntry() {
    return await Axios.get(API_HOST + "/user/entrycheck", axiosRequest)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            return false;
        });
}

async function updatePhoneDetails(countryCode, phoneNo) {
    return await axiosInstance.post(API_HOST + "/user/update-phone/" + countryCode + "/" + getuserId() + "?phoneNo=" + phoneNo, {}, axiosRequestWithAuth)
        .then((resp) => {
            return resp.data.body;
        })
        .catch((err) => {
            return false;
        });
}

async function isSkipLimitUser() {
    return await Axios.get(API_HOST + "/limit/" + getuserId(), axiosRequest)
        .then((resp) => {
            return resp.data;
        })
        .catch((err) => {
            return false;
        });
}

async function generateToken(email) {
    return await axiosInstance.post(API_HOST + "/user/generatetoken/" + email, {}, axiosRequestWithAuth).then(resp => {
        return resp.data;
    }).catch(err => {
        console.log(err);
        return false;
    });
}

async function deleteCancelUser(userid) {
    return await axiosInstance.delete(API_HOST + "/user/permenentdelete/" + getuserId() + "?deleteId=" + userid, axiosRequestWithAuth)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            return false;
        });
}

async function reactivateCancelledUser(userid) {
    return await axiosInstance.put(API_HOST + "/user/reactivateuser/" + getuserId() + "?subuserId=" + userid, {}, axiosRequestWithAuth)
        .then((resp) => {
            return resp;
        })
        .catch((err) => {
            return false;
        });
}

async function getSuspendMsg(userId) {
    return await axiosInstance.get(API_HOST + "/user/suspension/details/" + userId, axiosRequestWithAuth).then(resp => {
        if(resp.status === 204) {
            return false;
        }
        return resp.data;
    }).catch(error => {
        return Promise.reject(error);
    });
}

async function fetchActiveEmailTransfer(userId) {
    return await axiosInstance.get(API_HOST + "/user/profile/email/" + userId + "?status=ACTIVE", axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
}

async function requestEmailTransfer(userId, emailTransferDto, captchaToken) {
    return await axiosInstance.post(API_HOST + "/user/profile/email/" + userId + "?captcha=" + captchaToken, emailTransferDto, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
}

async function processEmailTransfer(userId) {
    return await axiosInstance.get(API_HOST + "/user/profile/email/process/" + userId, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
}

async function cancelEmailTransfer(transferId, userId) {
    return await axiosInstance.put(API_HOST + "/user/profile/email/" + transferId + "/" + userId, null, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
}

async function resendEmailTransferEmail(transferId, userId, captchaToken) {
    return await axiosInstance.get(API_HOST + "/user/profile/email/" + transferId + "/resend/" + userId + "?captcha=" + captchaToken, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
}
